export var getTimeFromDate = function getTimeFromDate(date) {
  var hours = String(date.getHours()).padStart(2, '0');
  var minutes = String(date.getMinutes()).padStart(2, '0');
  return "".concat(hours, ":").concat(minutes);
};